module.exports = __webpack_public_path__ + "img/v4_followDetail_h.7801f740.png";